// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"160":"8227fd38","189":"96185ed5","240":"e4b7130a","536":"ce53add7","677":"cf2909c9","834":"313cd607","950":"2bbc05f1"}[chunkId] + ".css";
};